/**
 * Popoverの開閉アニメーションが終わるまで待機する
 * DialogもPopoverを継承しているので、この関数が使用できる
 *
 * @note
 * Popoverの開閉アニメーションは150msかかる。
 * これはtailwind-animateの`animate-in`/`animate-out`クラスによるもので、
 * これらのアニメーション時間は以下に設定されている。
 *
 * https://github.com/jamiebuilds/tailwindcss-animate/blob/ac0dd3a3c81681b78f1d8ea5e7478044213995e1/index.js#L16
 *
 * `animationDuration.DEFAULT`は`transitionDuration.DEFAULT`と同じ値であり、デフォルトの値は150msである。
 *
 * https://github.com/tailwindlabs/tailwindcss/blob/1f23c2e8421cf8f674cf4dfe9940e51ff21f3d4a/stubs/config.full.js#L935
 */
export async function waitForPopoverAnimation() {
  await new Promise((resolve) => setTimeout(resolve, 150));
}
